<div class="container container--mobile-padding contact-page">
	<div #yamaps class="map-block"></div>
</div>

<div class="container container--mobile-padding-more contact-page">
	<div class="contact-page__content">
		<div class="contact-page__left">
			<h2>BBDO Moscow</h2>
			<p [innerHTML]="contactInfo.contactInfo[currentLang]"></p>
		</div>
		<div class="contact-page__right">
			<h2 class="light-gray">{{contactInfo.title[currentLang]}}</h2>
			<p [innerHTML]="contactInfo.getInfo[currentLang]"></p>
		</div>
	</div>
</div>
